import{getUrl}from'@shopgate/pwa-common/selectors/url';/**
 * Gets the checkout url.
 * @param {Object} state The application state.
 * @return {string|null}
 */export var getCheckoutUrl=function getCheckoutUrl(state){return getUrl(state,{type:'checkout'});};